module.exports = __webpack_public_path__ + "media/images/american-express-9318e818944720c827ee38ef2f1282a8.png";